module.exports = __webpack_public_path__ + "static/media/android.9597ceb1.svg";